<template>
  <label class="check-box" :class="{ small }">
    <input v-bind="$attrs" type="checkbox" :checked="isChecked" v-on="changeListeners" />
    <div class="box" :class="{ checked: isChecked }">
      <CheckIcon v-if="isChecked" class="check" />
    </div>
    <!-- @slot ラベル -->
    <span v-if="$slots.default" class="label">
      <slot />
    </span>
  </label>
</template>

<script>
import { isEqual } from 'lodash'
import CheckIcon from '@/components/icons/check'

/**
 * チェックボックス
 *
 * `<input type="checkbox">` をラップしており、その全ての props を使用できます
 */
export default {
  name: 'CheckBox',
  components: {
    CheckIcon,
  },
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    /** `checked` に配列を指定した場合、その配列に `value` が含まれていればチェック状態になります */
    value: { type: [String, Number, Object], default: null },
    /** チェック状態。配列を指定した場合は `value` との組み合わせでチェック状態になります */
    checked: { type: [Boolean, Array], default: false },
    /** スモールサイズ */
    small: { type: Boolean, default: false },
  },
  computed: {
    isArray() {
      return Array.isArray(this.checked)
    },
    isChecked() {
      return this.isArray ? this.checked.some(item => isEqual(item, this.value)) : this.checked
    },
    changeListeners() {
      return { ...this.$listeners, change: this.handleChange }
    },
  },
  methods: {
    handleChange(e) {
      if (this.isArray) {
        this.$emit(
          'change',
          e.target.checked ? this.checked.concat(this.value) : this.checked.filter(item => !isEqual(item, this.value)),
        )
      } else {
        this.$emit('change', e.target.checked)
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.check-box {
  cursor: pointer;
  display: inline-flex;
  justify-content: flex-start;
  position: relative;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  & > input {
    display: none;
  }
}

.box {
  appearance: none;
  background: var(--white);
  border: solid 2px var(--dark-gray);
  border-radius: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
  height: 18px;
  margin: 4px;
  outline: none;
  position: relative;
  width: 18px;

  &.checked {
    background: var(--brand-color);
    border: 0;
  }
}

.check {
  fill: var(--white);
  height: 18px;
  position: absolute;
  width: 18px;
}

.label {
  display: inline-flex;
  line-height: 26px;
  margin-left: 8px;
  position: relative;
}

.small {
  & .box {
    border-radius: 50%;
    border-width: 1px;
    height: 16px;
    width: 16px;
  }

  & .check {
    height: 14px;
    padding: 1px;
    width: 14px;
  }
}

input:disabled {
  & + .box {
    background: var(--mostly-white-1);
    border-color: var(--border-color);
    cursor: default;
    fill: var(--mostly-white-1);
    &.checked {
      background: var(--light-gray);
    }
  }
  & ~ .label {
    color: var(--gray);
    cursor: default;
  }
}
</style>
